// One flow per open dialog. Provider state decides whether recovery is needed.
export function createQrLogin({
  api, id, valid, image, message, error, connected,
  hidden = () => document.hidden,
  now = () => Date.now(),
  schedule = (fn) => setTimeout(fn, 5000),
  cancel = (timer) => clearTimeout(timer),
}) {
  let stopped = false, timer, failures = 0, recoveries = 0;
  const opened = now();
  let waitingSince = opened, waiting = true;
  const alive = () => !stopped && valid();
  const stop = () => { stopped = true; cancel(timer); };
  const finish = (text) => { image(null); message(text); stop(); };
  async function update() {
    if (!alive()) return;
    if (now() - opened >= 600000) {
      finish('扫码窗口已超时，请重新打开获取二维码。');
      return;
    }
    if (hidden()) { timer = schedule(update); return; }
    if (waiting && now() - waitingSince >= 60000) {
      finish('暂未获取到有效二维码，请重新打开重试；若持续失败，请检查账号连接。');
      return;
    }
    try {
      const result = await api.prepareQr(id, recoveries < 2);
      if (!alive()) return;
      if (result.recovery_started) recoveries += 1;
      if (result.state === 'connected') {
        finish('已连接，无需扫码。');
        connected();
        return;
      }
      if (result.state === 'ready') {
        const blob = await api.qr(id);
        if (!alive()) return;
        image(blob);
        waitingSince = now();
        waiting = false;
        message('WhatsApp → 已关联设备 → 关联设备。二维码每 5 秒自动更新。');
      } else {
        image(null);
        if (!waiting) { waitingSince = now(); waiting = true; }
        if (result.state === 'failed' || now() - waitingSince >= 60000) {
          finish('暂未获取到有效二维码，请重新打开重试；若持续失败，请检查账号连接。');
          return;
        }
        message('正在准备新的登录二维码，请稍候…');
      }
      failures = 0;
    } catch (e) {
      if (!alive()) return;
      image(null);
      error(e);
      if (!alive()) return;
      const code = e.response?.status;
      if ([401, 403, 404, 410, 429].includes(code) || ++failures >= 3) {
        finish('二维码读取失败，请重新打开重试。');
        return;
      }
      message('二维码暂不可用，正在重新核对连接状态…');
    }
    if (alive()) timer = schedule(update);
  }
  return { start: update, stop };
}
